<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { VisXYContainer, VisGroupedBar, VisAxis } from '@unovis/vue';
import {
  Card,
  CardHeader,
  CardContent,
} from 'dashboard/components-next/ui-shadcn/card';

const props = defineProps({
  // 24-length array where index is the hour of day (0-23) and value the count.
  hours: { type: Array, default: () => Array.from({ length: 24 }, () => 0) },
});

const { t } = useI18n();

const chartData = computed(() =>
  Array.from({ length: 24 }, (_, hour) => ({
    hour,
    value: props.hours[hour] || 0,
  }))
);

const total = computed(() =>
  chartData.value.reduce((sum, d) => sum + d.value, 0)
);

const x = d => d.hour;
const y = d => d.value;
const tickFormat = h => (h % 4 === 0 ? `${h}h` : '');
const barColor = () => '#1F61F4';
</script>

<template>
  <Card>
    <CardHeader>
      <div class="min-w-0">
        <h3 class="text-base font-semibold text-n-slate-12">
          {{ t('PAINEL_PRINCIPAL.TRAFFIC.TITLE') }}
        </h3>
        <p class="text-xs text-n-slate-10 truncate">
          {{ t('PAINEL_PRINCIPAL.TRAFFIC.SUBTITLE') }}
        </p>
      </div>
      <span class="text-2xl font-bold text-n-slate-12 shrink-0">{{
        total
      }}</span>
    </CardHeader>
    <CardContent class="pt-0">
      <div class="h-44">
        <VisXYContainer
          :data="chartData"
          :height="176"
          :margin="{ top: 4, right: 0, bottom: 18, left: 0 }"
        >
          <VisGroupedBar
            :x="x"
            :y="y"
            :bar-padding="0.3"
            :rounded-corners="4"
            :color="barColor"
          />
          <VisAxis
            type="x"
            :tick-format="tickFormat"
            :grid-line="false"
            :domain-line="false"
            :tick-line="false"
            tick-text-color="rgb(var(--slate-10))"
            :num-ticks="24"
          />
        </VisXYContainer>
      </div>
    </CardContent>
  </Card>
</template>
